import { E as EVENTS } from './events-58bc9098.js';

class CartCount extends HTMLElement {
  constructor() {
    super();
    this.classes = {
      prepareToUpdate: "prepare-to-update",
      updated: "updated",
    };
  }

  connectedCallback() {
    this.eventController = new AbortController();
    const { signal } = this.eventController;

    console.log('[cart-count] connectedCallback, dataset.cartCount=', this.dataset.cartCount);

    // Primary update path: fired immediately after every cart mutation
    document.addEventListener(
      EVENTS.CART_CHANGED,
      this.handleCartChange.bind(this),
      { signal },
    );

    // Fallback update path: fired 1 s after add-to-cart (after cart drawer opens).
    // Guards against any edge case where CART_CHANGED arrives but handleCartChange
    // bails early (e.g. detail missing), by re-fetching the count from the server.
    document.addEventListener(
      EVENTS.CART_ITEM_ADDED,
      this.handleCartItemAdded.bind(this),
      { signal },
    );

    // After a section re-render the element is reconnected but CART_CHANGED
    // has already fired. Sync immediately from the in-memory cart so the
    // displayed count is never stale.
    const latestCount = window.theme?.cartData?.item_count;
    if (Number.isInteger(latestCount)) {
      this._applyCount(latestCount);
    }
  }

  disconnectedCallback() {
    this.eventController.abort();
  }

  handleCartChange(event) {
    console.log('[cart-count] CART_CHANGED received, detail=', event.detail);
    if (!event.detail?.cartData || !Number.isInteger(event.detail.cartData.item_count)) {
      console.warn('[cart-count] CART_CHANGED: bailing — invalid cartData');
      return;
    }
    const newCount = event.detail.cartData.item_count;
    console.log('[cart-count] CART_CHANGED: newCount=', newCount, 'current dataset=', this.dataset.cartCount);
    // Update window.theme cache so connectedCallback self-heal works correctly
    // after section re-renders.
    if (window.theme) window.theme.cartData = event.detail.cartData;
    this._applyCount(newCount);
  }

  handleCartItemAdded(event) {
    // CART_CHANGED should have already fired, but if the count in the element
    // still looks stale compared to window.theme.cartData, sync it.
    const latestCount = window.theme?.cartData?.item_count;
    if (!Number.isInteger(latestCount)) return;
    const currentCount = parseInt(this.dataset.cartCount, 10);
    if (latestCount !== currentCount) {
      this._applyCount(latestCount);
    }
  }

  _applyCount(newCount) {
    const currentCount = parseInt(this.dataset.cartCount, 10);
    console.log('[cart-count] _applyCount: newCount=', newCount, 'currentCount=', currentCount);
    if (newCount === currentCount) {
      console.log('[cart-count] _applyCount: skipped — same count');
      return;
    }

    // Update data attribute and text immediately — no setTimeout — so the
    // DOM reflects the new count even if the page navigates shortly after.
    const label = newCount > 99 ? "99+" : String(newCount);
    this.innerText = label;
    this.dataset.cartCount = newCount;

    // CSS animation classes (purely cosmetic, safe to apply async)
    this.classList.add(this.classes.prepareToUpdate);
    setTimeout(() => {
      this.classList.add(this.classes.updated);
      setTimeout(() => {
        this.classList.remove(
          this.classes.prepareToUpdate,
          this.classes.updated,
        );
      }, 320);
    }, 0);
  }
}

if (!customElements.get("cart-count")) {
  customElements.define("cart-count", CartCount);
}
